<script setup lang="ts">
import { useWatchErrorHandler } from '@errors/useErrorHandler';
import type { CrmAdviseursGetAdviseursDto as Adviseur } from '@services/crm-internal/api';
import FloatLabel from '@shared/form-v2/FloatLabel/FloatLabel.vue';
import VSelect from '@shared/form/VSelect/VSelect.vue';
import { useId } from '@tools/composables/id';
import { watch } from 'vue';
import { useField } from 'vee-validate';
import { useAdviseurs } from './adviseurs';

const { data, error, isPending } = useAdviseurs();
const { value } = useField('adviseur');
const id = useId('adviseur-selectie');
watch(
  data,
  (adviseurs) => (value.value = adviseurs?.find(({ adviseurnummer }) => adviseurnummer === 1)),
  { immediate: true },
);
useWatchErrorHandler(error);
</script>

<template>
  <form @submit.prevent>
    <FloatLabel>
      <VSelect
        v-model="value"
        v-slot="{ option }"
        :id
        :loading="isPending"
        :option-label="({ name }: Adviseur) => name ?? ''"
        :options="data"
        searchable
      >
        <span class="flex gap-ch">
          <span v-if="option.name">
            {{ option.name }}
          </span>

          <span class="ml-auto text-sm text-grey"> #{{ option.id }} </span>
        </span>
      </VSelect>

      <label :for="id"> Adviseur </label>
    </FloatLabel>
  </form>
</template>
